

const ENDPOINT = 'https://mrblue.apps.bydas.com';
var useDiscount = false;
var current_cart
var current_discounts_before_bluecoins=0
var current_order_total=0;
var BLUECOINS;
var bcoins_active=false;



document.addEventListener("DOMContentLoaded", function() {
  if (document.body.classList.contains('template-cart')) {
    startBluecoins();
  }
});

/* Detetar página de conta e introduzir elemento de menu para aceder ao histórico das bluecoins */
document.addEventListener("DOMContentLoaded", function() {
  
    if (document.body.classList.contains('template-customers-account') || document.body.classList.contains('template-suffix-bluecoins')) {
        const logoutLink = Array.from(document.querySelectorAll('a')).find(link =>
            /^\/([a-z]{2}\/)?account\/logout$/.test(link.getAttribute('href'))
        );

        if (logoutLink) {
            // Criar o novo link
            const newLink = document.createElement('a');
            newLink.href = bluecoins_history_page;
            newLink.innerHTML = bluecoins_history_page_label;
            newLink.classList.add('bluecoins-menu');
            if (document.body.classList.contains('template-suffix-bluecoins')){
              newLink.classList.add('active');
            }
          
            // Inserir antes do link de logout
            logoutLink.parentNode.insertBefore(newLink, logoutLink);

            const newLink2 = document.createElement('a');
            newLink2.href = bluecoins_account_page;
            newLink2.textContent = bluecoins_account_page_label;
            newLink2.classList.add('bluecoins-menu');
            if (document.body.classList.contains('template-customers-account')){
              newLink2.classList.add('active');
            }
            // Inserir antes do link de logout
            logoutLink.parentNode.insertBefore(newLink2, logoutLink);
        }
    }
});

function bluecoinsTranslateHistory(){
      const container = document.getElementById('bluecoins_history');
      if (!container) return;
    
      // Substituir os <th>
      const ths = container.querySelectorAll('thead th');
      if (ths.length >= 3) {
        ths[0].textContent = bluecoins_history_table_date;
        ths[1].textContent = bluecoins_history_table_discount;
        ths[2].textContent = bluecoins_history_table_order;
      }
    
      // Substituir "arquivada" nos <td>
      const tds = container.querySelectorAll('tbody td');
      tds.forEach(td => {
        if (td.textContent.trim().toLowerCase() === 'arquivada') {
          td.textContent = bluecoins_history_table_archived;
        }
      });
}


function startBluecoins(payload){
    console.log("Checking Bluecoins...")
    // Verifica se há descontos com "BCOINS"
    /*
    document.querySelectorAll(".CartItem__Discount").forEach(function(el) {
        if (el.textContent.includes("BCOINS")) {
            bcoins_active = true;
        }
    });
    */

  

  
    // Move o elemento #bluecoins para a posição correta se ainda não estiver lá
    if (!document.querySelector(".checkout-subtotal-container__left #bluecoins")) {
        let bluecoins = document.getElementById("bluecoins");
        if (bluecoins) {
            let cartNote = document.querySelector(".checkout-subtotal-container__left cart-note");
            if (cartNote && cartNote.parentNode) {
                cartNote.parentNode.insertBefore(bluecoins, cartNote);
            }
        }
    }
    
    // Limpa o conteúdo da div .bluecoins_container
    document.querySelectorAll(".bluecoins_container").forEach(function(el) {
        el.innerHTML = "";
    });
    
    // Exibe o elemento #bluecoins
    let bluecoinsElement = document.getElementById("bluecoins");
    if (bluecoinsElement) {
        bluecoinsElement.style.display = "block";
    }
    
    // Atualiza a mensagem do loader de Bluecoins
    let loader = document.querySelector(".bluecoins_loader");
    if (loader) {
        loader.innerHTML = bluecoins_history_loading;
    }
    
    // Verifica a variável CID
    if (typeof CID === 'undefined' || !CID) {
        if (loader) {
            loader.innerHTML = '<span>'+bluecoins_history_login+'.</span>';
        }
        return;
    }

    console.log("CID: "+CID)
    // Obtém os dados do carrinho via JSON

    if (payload){
      console.log("PAYLOAD: "+payload)
      processBlueCoins(payload)
      return
    } 
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
          console.log("CART",data)
            if (data.token) {

              // PROCURAR POR BLUECOINS ATIVAS
              var bcoins_found=0;
              
              const discountElements = document.querySelectorAll('.cart-discount__title');

              for (let i = 0; i < discountElements.length; i++) {
                const title = discountElements[i].textContent.trim();
                
                if (title.toUpperCase().startsWith("BCOINS-")) {
                  console.log("Desconto BCOINS encontrado na interface:", title);
                  bcoins_found++;
  
                }
              }

              
              /* SE EXISTIR DESCONTO BCOIN, REMOVER */
              if (bcoins_found>0){
                 fetch('/checkout?discount=CLEAR').then(function(e){
                    console.log("Discount removed from checkout");
                    startBluecoins();
                   
                  })
               } else {
               /* SE NÃO EXISTIR, CONTINUAR */
                 processBlueCoins(data)
               }

    
            } else {
                alert(bluecoins_history_error5);
            }
        })
        .catch(() => {
            alert(bluecoins_history_error6);
        });



     
  } /* fim da função*/

  function processBlueCoins(data){
    current_cart = data;
    current_order_total = data.total_price / 100;
    current_discounts_before_bluecoins = data.total_discount / 100;
    console.log(data);
  
    // Envia requisição para obter BlueCoins
    fetch(ENDPOINT + "?action=bluecoins&id=" + CID + "&store=" + CHANNEL +
        "&total=" + data.total_price + "&discounts=" + data.total_discount)
        .then(response => response.text())
        .then(responseText => {
            console.log("RECEBIDOS OS BLUE POINTS");
            let parsedData;
  
            try {
                parsedData = JSON.parse(responseText);
            } catch (e) {
                document.querySelector(".bluecoins_loader").innerHTML =
                    '<span style="color:#f00">'+bluecoins_history_error7+'</span>';
                document.querySelector(".bluecoins_loader span a").addEventListener("click", function (e) {
                    e.preventDefault();
                    startBluecoins();
                });
                return false;
            }
  
            if (parsedData.status == 1) {
                if (parsedData.balance > 0) {
                    BLUECOINS = parsedData.discount;
                    document.querySelector(".bluecoins_loader").classList.add("hidden");
  
                    let stotal = String(parsedData.total).replace(".", ",");
                    let smaximum = String(parsedData.maximum).replace(".", ",");
                    let sbalance = String(parsedData.balance).replace(".", ",");
                    let sdiscount = String(parsedData.discount).replace(".", ",");
  
                    let html = `
                        <p>${bluecoins_history_notice9}</p>
                    `;
  
                    if (bcoins_active === true) {
                        html += `<button type="button" class="bluecoins-button" data-value="25" disabled>${bluecoins_history_notice7}</button>`;
                    } else {
                        html += `<button type="button" class="bluecoins-button" data-value="25">${bluecoins_history_notice8} <span>${sdiscount}</span>€</button>`;
                    }
  
                    html += `
                        <p><small><strong><span class="bluecoins">*</span></strong> ${bluecoins_history_notice4},
                        <br>${bluecoins_history_notice5}.<br><a href="/pages/clube-blue-for-you" target="_blank">${bluecoins_history_notice6}</a></small></p>
                    `;
                    
                    document.querySelector(".bluecoins_container").innerHTML = html;
  
                    document.querySelector(".bluecoins_container").setAttribute("data-total", stotal + "€");
                    document.querySelector(".bluecoins_container").setAttribute("data-discount", sdiscount + "€");
                } else {
                    document.querySelector(".bluecoins_loader").innerHTML =
                        '<span style="color:#307b97">'+bluecoins_history_notice1+' <a href="/pages/bluecoins"><strong>'+bluecoins_history_notice2+'</strong></a></span>';
                }
  
            } else {
                if (parsedData.card == 0) {
                    document.querySelector(".bluecoins_loader").innerHTML =
                        `<strong><span style="color:#307b97">Blue</span>Coins</strong><br><span>${parsedData.msg}.</span>`;
                } else {
                    document.querySelector(".bluecoins_loader").innerHTML =
                        `<span style="color:#f00">${parsedData.msg}.<br><a href="#"><strong>${bluecoins_history_notice3}</strong></a></span>`; // erro de comunicação. tentar novamente
  
                    document.querySelector(".bluecoins_loader span a").addEventListener("click", function (e) {
                        e.preventDefault();
                        startBluecoins();
                    });
                }
            }
        })
        .catch(() => {
            document.querySelector(".bluecoins_loader").innerHTML =
                '<span style="color:#f00">'+bluecoins_history_error4+'. <a href="#"><strong>'+bluecoins_history_notice3+'</strong></a></span>';
            document.querySelector(".bluecoins_loader span a").addEventListener("click", function (e) {
                e.preventDefault();
                startBluecoins();
            });
        });
  }




  (function() {
  const originalFetch = window.fetch;
  
  window.fetch = function() {
    const args = arguments;

    // Verifica se é uma chamada ao cart
    const url = (typeof args[0] === 'string') ? args[0] : args[0].url;

    const isCartUpdate =url.includes('/cart/update')
    
    return originalFetch.apply(this, args).then(response => {
      
      if (isCartUpdate && response.ok ) {
         
        const clonedResponse = response.clone();

        clonedResponse.json().then(cartData => {
          // ⚡ Aqui é onde corres o que quiseres com o novo payload
          console.log("CARRINHO ATUALIZADO:", cartData);
          startBluecoins(cartData);
        });
      }

      return response;
    });
  };

})();



   // Evento de clique no botão .bluecoins-button
  document.addEventListener("click", function (e) {
      if (e.target.classList.contains("bluecoins-button")) {
          e.preventDefault();
          e.target.disabled = true;
          e.target.style.opacity = 0.5;

          const bcontainer = document.querySelector(".bluecoins_container");

          var total = bcontainer.getAttribute("data-total");
          var discount = bcontainer.getAttribute("data-discount");
          total=bluecoins_format(total)+"€"
          discount=bluecoins_format(discount)+"€"
          
          
          
          
          // Cria os novos elementos
        const container = document.querySelector('.checkout-subtotal-container__right');
          const subtotalElement = container.querySelector('h2.subtotal.h2');
          const descontoDiv = document.createElement('div');
          descontoDiv.innerHTML = `
            <h2 class="bluecoins_total_discount h4">
              <span class="bluecoins">${bluecoins_history_page_label}</span>:
              <span class="theme-money">-${discount}</span>
            </h2>
          `;
          
          const totalDiv = document.createElement('div');
          totalDiv.innerHTML = `
            <h2 class="bluecoins_total_amount h4">
              Total:
              <span class="theme-money">${total}</span>
            </h2>
          `;
          
          // Insere os elementos imediatamente a seguir ao subtotal
          if (subtotalElement && subtotalElement.parentNode) {
            subtotalElement.parentNode.insertBefore(totalDiv, subtotalElement.nextSibling);
            subtotalElement.parentNode.insertBefore(descontoDiv, totalDiv);
          }

        

          useDiscount = true;
      }
  });
  function bluecoins_format(valor) {
    // Remove o símbolo do euro se existir e converte para número
    let numero = parseFloat(valor.replace('€', '').replace(',', '.'));
    if (isNaN(numero)) numero = 0;
    // Formata com duas casas decimais e vírgula como separador decimal
    return numero.toFixed(2).replace('.', ',');
  }
/*
  const delayReload = () => {
    setTimeout(() => {
      location.reload();
    }, 1000);
  };
  */  
  // Alteração manual no input
  document.querySelectorAll(".cart-item__quantity-input").forEach(input => {
    input.addEventListener("input", startBluecoins);
    console.log("input")
    
    
  });

  // Botões de incrementar/decrementar
  document.querySelectorAll(".quantity-down, .quantity-up").forEach(btn => {
    //btn.addEventListener("click", delayReload);
    console.log("buttons")
   startBluecoins()
  });

  // Link "Remover"
  document.querySelectorAll("a[href*='quantity=0']").forEach(link => {
    //link.addEventListener("click", delayReload);
    console.log("remove")
    startBluecoins()
  });



  document.addEventListener("click", function (e) {
  const checkoutBtn = e.target.closest('#update-cart');

  if (checkoutBtn) {
    if (useDiscount) {
      e.preventDefault();

      // Desativa o botão temporariamente para evitar múltiplos cliques
      checkoutBtn.disabled = true;

      fetch(ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
          action: "bluecoins",
          id: CID,
          cart: JSON.stringify(current_cart),
          store: CHANNEL
        })
      })
        .then(response => response.text())
        .then(responseText => {
          console.log(responseText);

          let data;
          try {
            data = JSON.parse(responseText);
          } catch (e) {
            return false;
          }

          if (data.status == 1) {
            window.location.href = '/checkout?discount=' + data.code;
            return true;
          } else {
            console.log(data);
            checkoutBtn.disabled = false;
            return false;
          }
        })
        .catch(error => {
          console.log(error);
          checkoutBtn.disabled = false;
          return false;
        });
    } else {
      return true;
    }
  }
});


/* THANK YOU PAGE */
/*
if (document.querySelector("html.page--thank-you")) {
    console.log("checking if there are bluecoins in use");
    console.log("ORDER ID: " + Shopify.checkout.order_id);
    console.log("CUSTOMER ID: " + Shopify.checkout.customer_id);

    if (Shopify.checkout.discount && Shopify.checkout.discount.code) {
        console.log("DISCOUNT: " + Shopify.checkout.discount.code);

        if (Shopify.checkout.discount.code.includes("BCOINS-")) {
            console.log("Blue coins found");

            fetch("https://mrblue.apps.bydas.com", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams({
                    action: "bluecoins_charge",
                    customer: Shopify.checkout.customer_id,
                    order: Shopify.checkout.order_id,
                    code: Shopify.checkout.discount.code,
                    store: 0
                })
            })
            .then(response => response.text())
            .then(responseText => {
                console.log("RESPONSE");
                console.log(responseText);

                try {
                    let data = JSON.parse(responseText);
                } catch (e) {
                    return false;
                }
            })
            .catch(error => {
                console.log("RESPONSE");
                console.log(error);
            });

        } else {
            console.log("NO BLUECOINS FOUND IN THE ORDER");
        }
    } else {
        console.log("NO DISCOUNTS FOUND IN THE ORDER");
    }
}
*/


/* ACCOUNT PAGE */
if (document.getElementById("bluecoins_history")) {
    fetch(ENDPOINT + "?action=bluecoins_history&id=" + CID + "&store=" + CHANNEL)
        .then(response => response.text())
        .then(responseText => {
            let data;
            try {
                data = JSON.parse(responseText);
            } catch (e) {
                return;
            }

            if (data.status && data.status == 1) {
                let html = '';

                document.querySelector("#bluecoins_history_card span").textContent = data.card;
                document.querySelector("#bluecoins_history_balance span").textContent = data.balance + "€";

                if (data.data && data.data.length > 0) {
                    html += '<table width="100%">';
                    html += '<thead>';
                    html += '<tr>';
                    html += '<th style="text-align:center">'+bluecoins_history_table_date+'</th>';
                    html += '<th style="text-align:right">'+bluecoins_history_table_discount+'</th>';
                    html += '<th style="text-align:center">'+bluecoins_history_table_order+'</th>';
                    html += '</tr>';
                    html += '</thead>';
                    html += '<tbody>';

                    data.data.forEach(item => {
                        html += '<tr>';
                        html += '<td style="text-align:center">' + item.date + '</td>';
                        html += '<td style="text-align:right">' + item.discount + '€</td>';
                        html += '<td style="text-align:center">' + (item.order && item.order > 0 ? item.order_name : 'n/a') + '</td>';
                        html += '</tr>';
                    });

                    html += '</tbody>';
                    html += '</table>';

                    document.getElementById("bluecoins_history").insertAdjacentHTML("beforeend", html);
                } else {
                    document.getElementById("bluecoins_history").insertAdjacentHTML("beforeend", '<h3>'+bluecoins_history_error1+'</h3>');
                }
            } else {
                document.querySelector("#bluecoins_history_card span").textContent = "------";
                document.querySelector("#bluecoins_history_balance span").textContent = "------";
                document.getElementById("bluecoins_history").insertAdjacentHTML("beforeend", '<h3>'+bluecoins_history_error2+'</h3>');
            }
        })
        .catch(() => {
            document.querySelector("#bluecoins_history_card span").textContent = "------";
            document.querySelector("#bluecoins_history_balance span").textContent = "------";
            document.getElementById("bluecoins_history").insertAdjacentHTML("beforeend", '<h3 class="bluecoins_notice">'+bluecoins_history_error3+'.</h3>');
        });
}




